var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckBoxActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00039 2.40002H18.0004C19.9886 2.40002 21.6004 4.0118 21.6004 6.00002V18C21.6004 19.9882 19.9886 21.6 18.0004 21.6H6.00039C4.01217 21.6 2.40039 19.9882 2.40039 18V6.00002C2.40039 4.0118 4.01217 2.40002 6.00039 2.40002Z",
    fill: "#2346F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83208 11.136C8.36043 10.6705 7.60064 10.6754 7.13506 11.147C6.66947 11.6187 6.67439 12.3785 7.14605 12.8441L10.1952 15.854C10.6968 16.3491 11.5152 16.3074 11.9638 15.7637L16.9146 9.7637C17.3364 9.25251 17.264 8.49618 16.7528 8.07438C16.2416 7.65258 15.4853 7.72504 15.0635 8.23622L10.9476 13.2243L8.83208 11.136Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxActive);
export default __webpack_public_path__ + "static/media/checkBoxActive.3869fcbb7e247ca441560e97cb127a18.svg";
export { ForwardRef as ReactComponent };